import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import Sentry from "./config/sentry";
import "./config/mixpanel";
import "./index.css";

const domNode = document.getElementById("root");

if (!domNode) {
  throw new Error("Root element not found");
}

createRoot(domNode, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  onCaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
